// extracted by mini-css-extract-plugin
module.exports = {"resourcePersona":"ResourcePersona_resourcePersona__1DdO2","resourcePersonaIcon":"ResourcePersona_resourcePersonaIcon__3aOj1"};